<template>
  <div class="grid-y flex-grow">
    <Loading :loading="waitPending">
      <div class="cell p-8">
        <div
          class="flex flex-row space-x-10">
          <Input
            label="Порог отключения исполнителя"
            classes="bg-hint border-none"
            @keyup.enter.native="($event) => $event.target.blur()"
            @blur="save"
            :inputmask="{
            alias: 'decimal',
            rightAlign: false,
            allowMinus: true,
          }"
            :disabled="$wait.is('update.configs')"
            :value="$delve(local, 'contractorMinimalBalance')"
            @input="(value) => $set(local, 'contractorMinimalBalance', value)"/>
        </div>
      </div>
      <div class="cell flex-grow flex flex-col">
        <div class="flex-grow">
          <Table
            :columns="columns"
            :rows="contractors"
            :row-style-class="() => 'cursor-pointer'"
            :busy="waitPending"
            @on-row-click="onRowClick"
            @on-sort-change="($event) => {orderBy = $event}"/>
        </div>
        <div class="flex flex-row items-end justify-center p-6">
          <Pagination
            :page="page"
            :page-count="pageCount"
            @change="onPageChange"/>
        </div>
      </div>
    </Loading>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import Input from '@/components/Input.vue';
import Table from '@/components/Table.vue';
import Pagination from '@/components/Pagination.vue';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    Input,
    Table,
    Pagination,
    Loading,
  },
  data() {
    return {
      local: null,
      limit: 100,
      page: 1,
      orderBy: [],
    };
  },
  computed: {
    ...mapState({
      configs: (state) => state.settings.configs,
      payload: (state) => state.contractors.disabledContractors,
    }),
    columns() {
      return [
        {
          label: 'Компания или ФИО исполнителя',
          field: 'name',
          sortable: true,
        },
        {
          label: 'Дата отклонения',
          field: ' ',
          sortable: false,
        },
        {
          label: 'Баланс',
          field: 'balance',
          cell: ({ row }) => <b>{ this.$numeral(parseFloat(row.balance)).format('0,0 $') }</b>,
          sortable: true,
        },
        {
          label: 'Телефон',
          field: 'phone',
          sortable: true,
        },
        {
          label: 'Email',
          field: 'email',
          sortable: true,
        },
        {
          label: 'Контактное лицо',
          field: 'managerName',
          sortable: true,
        },
      ];
    },
    offset() {
      return (this.page - 1) * this.limit;
    },
    contractors() {
      return _.get(this.payload, 'payload') || [];
    },
    total() {
      return _.get(this.payload, 'total') || null;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    waitPending() {
      return this.$wait.is('fetch.configs')
        || this.$wait.is('fetch.disabled.contractors');
    },
  },
  methods: {
    ...mapActions({
      fetch: 'settings/ACT_FETCH_CONFIGS',
      update: 'settings/ACT_UPDATE_CONFIGS',
      fetchDisabled: 'contractors/ACT_FETCH_DISABLED_CONTRACTORS',
    }),
    save() {
      this.update(this.local);
    },
    fetchPayload() {
      let { orderBy } = this;
      if (_.isEqual(orderBy, [])) {
        orderBy = [
          { column: 'id', descending: 1 },
        ];
      }
      this.fetchDisabled({
        offset: this.offset,
        limit: this.limit,
        orderBy,
      });
    },
    onPageChange(event) {
      this.page = event;
    },
    onRowClick({ row: event }) {
      this.$router.push({
        name: 'contractors.details',
        params: {
          id: event.id,
        },
      });
    },
  },
  mounted() {
    this.local = _.cloneDeep(this.configs);
    this.fetch().then((data) => {
      this.local = _.cloneDeep(data);
    });
    this.$watch((that) => [that.page, that.orderBy, that.query], () => {
      this.fetchPayload();
    });
  },
  watch: {
    configs: {
      handler() {
        this.fetchPayload();
      },
      deep: true,
    },
  },
};
</script>
